import {
  ExportInterfaceConfigTemplateClient,
  ExportInterfaceConfigTemplateDetailsDTO,
  ExportInterfaceConfigurationFTPTestResultDTO,
  FilterDTO,
  FilterOperator,
  SortDirection, UpdateInterfaceUserInfoDTO,
  UserAccountClient,
  Role,
  FilterCondition,
} from 'src/app/base/models/models.swagger.generated';
import {
  ExportInterfaceConfigurationClient,
  ExportInterfaceConfigurationDetailsDTO,
  ExportInterfaceConfigurationDetailsFTPClientDTO,
  PagedResultDTOOfUserInfoDTO,
  UserInfoDTO,
} from './../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastService } from '../../base/services/toast.service';
import { ErrorType } from '../../core/routing/error-types';

@Injectable()
export class ExportConfigurationService extends ShowInactiveService {

  constructor(
    private exportInterfaceConfigurationClient: ExportInterfaceConfigurationClient,
    private exportInterfaceConfigTemplateClient: ExportInterfaceConfigTemplateClient,
    private accountClient: UserAccountClient,
    private toastService: ToastService,
  ) {
    super();
  }

  public getAllAccessUsers(clientId: number): Observable<UserInfoDTO[]> {
    const filters: FilterDTO[] = [new FilterDTO({
      isComplex: true,
      condition: FilterCondition.Or,
      predicates: [
        new FilterDTO({isComplex: false, field: 'Roles', operator: FilterOperator.Equal, value: Role.InterfaceServiceAccess.toString()}),
      ]
    }),
    new FilterDTO({
      isComplex: false,
      field: "Enabled",
      operator: FilterOperator.Equal,
      value: "true"
    })
    ];
    return this.accountClient.searchUsers(clientId, 0, 0, "userName", SortDirection.Ascending, filters).pipe(
      map((result: PagedResultDTOOfUserInfoDTO) => {
        return result.items;
      })
    );
  }

  public updateInterfaceUser(data: UpdateInterfaceUserInfoDTO): Observable<UserInfoDTO> {
    return this.accountClient.updateInterfaceUser(data).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.core.messages.user-edit.success-title',
          'i18n.core.messages.user-edit.success-message');
      }),
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.core.messages.user-edit.title', 'i18n.core.messages.user-edit.message', null, ErrorType.serverError, error.response);
        }
        return throwError(() => error);
      }),
    );
  }

  public getFilenameExampleFromString(config: ExportInterfaceConfigurationDetailsDTO) {
    return this.exportInterfaceConfigurationClient.getFilenameExampleFromConfig(config)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public getFilenameExampleFromStringTemplate(config: ExportInterfaceConfigTemplateDetailsDTO) {
    return this.exportInterfaceConfigTemplateClient.getFilenameExampleFromConfig(config)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public testFtpAccess(configurationId: number, ftpDTO: ExportInterfaceConfigurationDetailsFTPClientDTO): Observable<ExportInterfaceConfigurationFTPTestResultDTO> {
    return this.exportInterfaceConfigurationClient.testFTPAccess(configurationId, ftpDTO);
  }
}
